import { apiClient } from "../config/api.config";
import { Appointment } from "../types/appointment.definition";

export function getAppointmentById(id: string) {
  return apiClient.request({
    method: "get",
    url: `/appointments/${id}`,
  });
}

export function getAppointments() {
  return apiClient.request({
    method: "get",
    url: `/appointments`,
  });
}

export function getAppointmentByPatientId(patientId: number) {
  return apiClient.request({
    method: "get",
    url: `/appointments/patient/${patientId}`,
  });
}

export function getAppointmentByDoctorId(doctorId: number) {
  return apiClient.request({
    method: "get",
    url: `/appointments/${doctorId}`,
  });
}
export async function updateAppointment(data: Appointment, id: string) {
  const simulateTimer = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));
  await simulateTimer(1000);
  return apiClient.request({
    method: "put",
    url: `/appointments/${id}`,
    data,
  });
}
export function cancelAppointment(id: string) {
  return apiClient.request({
    method: "put",
    url: `/appointments/cancel/${id}`,
  });
}
export const createAppointment = async (
  appointmentData: Partial<Appointment>
) => {
  return apiClient.request({
    method: "post",
    url: `/appointments`,
    data: appointmentData,
  });
};
